// Keyboard & mouse state, edge-detected per frame. Coordinates are in low-res canvas pixels.

export class Input {
  down = new Set<string>();
  pressed = new Set<string>();
  typed: string[] = [];
  mx = 0;
  my = 0;
  lmb = false;
  rmb = false;
  lmbPressed = false;
  rmbPressed = false;
  lmbReleased = false;
  rmbReleased = false;
  wheel = 0;
  /** While set, keys become text instead of game commands. */
  textMode = false;
  /** While set, a DOM panel over the canvas has the keyboard, and the game sees none of it. */
  blocked = false;
  onGesture: (() => void) | null = null;
  onPaste: ((s: string) => void) | null = null;

  attach(canvas: HTMLCanvasElement, toCanvas: (cx: number, cy: number) => [number, number]): void {
    const move = (e: MouseEvent) => {
      [this.mx, this.my] = toCanvas(e.clientX, e.clientY);
    };
    window.addEventListener('mousemove', move);
    canvas.addEventListener('mousedown', (e) => {
      move(e);
      this.onGesture?.();
      if (e.button === 0) {
        this.lmb = true;
        this.lmbPressed = true;
      } else if (e.button === 2) {
        this.rmb = true;
        this.rmbPressed = true;
      }
      e.preventDefault();
    });
    window.addEventListener('mouseup', (e) => {
      if (e.button === 0) {
        this.lmb = false;
        this.lmbReleased = true;
      } else if (e.button === 2) {
        this.rmb = false;
        this.rmbReleased = true;
      }
    });
    canvas.addEventListener('contextmenu', (e) => e.preventDefault());
    canvas.addEventListener('wheel', (e) => {
      this.wheel += Math.sign(e.deltaY);
      e.preventDefault();
    }, { passive: false });

    window.addEventListener('keydown', (e) => {
      this.onGesture?.();
      if (this.blocked) return;
      const code = e.code;
      if (this.textMode) {
        if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
          this.typed.push(e.key);
          e.preventDefault();
        } else if (['Backspace', 'Enter', 'Escape', 'Tab'].includes(e.key)) {
          this.pressed.add(code);
          e.preventDefault();
        }
        return;
      }
      if (['Tab', 'AltLeft', 'AltRight', 'F1', 'Space', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backquote', 'Enter'].includes(code)) e.preventDefault();
      if (!e.repeat) this.pressed.add(code);
      this.down.add(code);
    });
    window.addEventListener('keyup', (e) => {
      this.down.delete(e.code);
    });
    window.addEventListener('blur', () => {
      this.down.clear();
      this.lmb = false;
      this.rmb = false;
    });
    window.addEventListener('paste', (e) => {
      if (!this.blocked && this.textMode) {
        const txt = e.clipboardData?.getData('text') ?? '';
        if (txt) this.onPaste?.(txt);
        e.preventDefault();
      }
    });
  }

  endFrame(): void {
    this.pressed.clear();
    this.typed.length = 0;
    this.lmbPressed = false;
    this.rmbPressed = false;
    this.lmbReleased = false;
    this.rmbReleased = false;
    this.wheel = 0;
  }
}

export const input = new Input();
